'use client'

import { useEffect, useState } from 'react'
import { useStore } from '@/domain/state'
import { Button } from '@/ui/atoms/button/Button'
import { useAnalyticsConsent } from './useAnalyticsConsent'

export function AnalyticsConsentBanner() {
  const [mounted, setMounted] = useState(false)
  const setConsent = useStore((state) => state.analyticsConsent.setConsent)
  const { status } = useAnalyticsConsent()

  useEffect(() => {
    setMounted(true)
  }, [])

  // Don't render until after hydration to avoid mismatch with persisted state
  if (!mounted || status !== 'pending') {
    return null
  }

  return (
    <div className="fixed inset-x-0 bottom-0 z-[999] border-white/10 border-t bg-background/95 px-4 py-4 backdrop-blur-sm md:px-6">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-4 md:flex-row md:justify-between">
        <p className="text-center text-muted-foreground text-sm md:text-left">
          Help us improve HypurrFi? We&apos;d like to record session replays to understand how users interact with our
          app. All inputs are masked and no personal data is stored.
        </p>
        <div className="flex shrink-0 gap-3">
          <Button variant="ghost" size="sm" onClick={() => setConsent('declined')}>
            Decline
          </Button>
          <Button variant="primary" size="sm" onClick={() => setConsent('accepted')}>
            Accept
          </Button>
        </div>
      </div>
    </div>
  )
}
